import {
  animate,
  group,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const topToBottom = trigger('topToBottom', [
  transition('* => *', [
    query(
      ':enter',
      style({
        transform: 'translateY(-100%) translateX(-100%)',
        opacity: 0,
      }),
      { optional: true }
    ),
    query(':leave', style({ transform: 'translateY(0%)', opacity: 1 }), {
      optional: true,
    }),

    group([
      query(
        ':enter',
        animate(
          '0.5s ease-in-out',
          style({
            transform: 'translateY(0%) translateX(-100%)',
            opacity: 1,
          })
        ),
        { optional: true }
      ),
      query(
        ':leave',
        animate(
          '0.2s ease-in-out',
          style({
            transform: 'translateY(100%)',
            opacity: 0,
          })
        ),
        { optional: true }
      ),
    ]),
  ]),
]);
